import * as S from './styles'
import { useOurHistory } from './useOurHistory'
import { Text } from '../../components/text'
import { TimelineItem } from '../../components/timelineItem'
import { Dropdown } from '@/components/dropdown'
import { OurHistory } from '@/service/api/culturePage/types'

export type OurHistoryContainerProps = {
  data: OurHistory
}

export const OurHistoryContainer: React.FC<OurHistoryContainerProps> = ({
  data,
}) => {
  const {
    selectedYear,
    checkIfColored,
    handleTimelinePointClick,
    isSmallDesktop,
    fontSize,
    handleNextYear,
    handlePreviousYear,
    responsive,
    timelineKeys,
  } = useOurHistory({ data })

  const lastYear = selectedYear === timelineKeys.at(-1)

  return (
    <S.OurHistoryContainer>
      <Text size={fontSize.title} color="black" className="title">
        {data.title}
      </Text>
      {!isSmallDesktop ? (
        <>
          <S.TimelineContainer
            responsive={responsive}
            autoPlay={false}
            infinite={false}
            arrows
            renderArrowsWhenDisabled
            customRightArrow={
              <S.ArrowContainer side="right">
                <S.ArrowImage
                  lastYear={lastYear}
                  side="right"
                  id="right-arrow"
                  onClick={() => handleNextYear(selectedYear)}
                />
              </S.ArrowContainer>
            }
            customLeftArrow={
              <S.ArrowContainer side="left">
                <S.ArrowImage
                  firstYear={selectedYear === Object.keys(data.timeline)[0]}
                  side="left"
                  id="left-arrow"
                  onClick={() => handlePreviousYear(selectedYear)}
                />
              </S.ArrowContainer>
            }
          >
            {data.timeline &&
              Object.keys(data.timeline).map((year) => (
                <div key={year} className="timeline-items">
                  <TimelineItem
                    year={year}
                    onClick={() => handleTimelinePointClick(year)}
                    isColored={checkIfColored(
                      Number(selectedYear),
                      Number(year),
                    )}
                    id={year}
                    key={year}
                    isSelected={selectedYear === year}
                  />
                  <S.TimelineDot
                    isSelectedLeft={selectedYear >= year}
                    isSelectedRight={year < selectedYear || lastYear}
                  />
                </div>
              ))}
          </S.TimelineContainer>
          <S.TextContainer>
            <Text
              size={fontSize.contentTitle}
              color="black"
              className="content-title"
            >
              {data.timeline?.[selectedYear]?.title}
            </Text>
            <Text
              size={fontSize.contentDescription}
              color="black"
              className="content-description"
            >
              {data.timeline?.[selectedYear]?.description}
            </Text>
          </S.TextContainer>
        </>
      ) : (
        Object.keys(data.timeline).map((year) => (
          <Dropdown
            key={year}
            label={year}
            content={data.timeline[year].description}
          />
        ))
      )}
    </S.OurHistoryContainer>
  )
}
